import React from 'react';

import { ComponentDto, RaptorComponentViewModel } from 'dto/raptor-component.dto';
import { TableUtils } from 'pages/private/components/table-utils';
import { AdvanceTable, TablePaginationConfig } from 'ui-lib';

interface ISelectComponentsStepProps {
    components: RaptorComponentViewModel[];
    selectedComponents: ComponentDto[];
    loading: boolean;
    onChange: (components: ComponentDto[]) => void;
    pagination?: TablePaginationConfig;
    onTableChange: any;
    refresh?: () => Promise<void>;
}

export const SelectComponentsStep = (props: ISelectComponentsStepProps): JSX.Element => (
    <AdvanceTable
        title='Components'
        loadingState={props.loading}
        toolbar={{
            onReload: props.refresh
        }}
        table={{
            rowKey: 'uuid',
            dataSource: props.components,
            pagination: props.pagination,
            onTableChange: props.onTableChange,
            columns: [
                TableUtils.createBasicFilterColumn<RaptorComponentViewModel>({ title: 'Name', key: 'name' }),
                TableUtils.createBasicFilterColumn<RaptorComponentViewModel>({ title: 'Account', key: 'accountName' }),
                TableUtils.createBasicEnumFilterColumn<RaptorComponentViewModel>({
                    title: 'Type',
                    key: 'type',
                    filters: Array.from(new Set(props.components.map((component) => component.type))).map((type) => ({
                        text: type,
                        value: type,
                    })),
                }),
                TableUtils.createTruncatedTextColumn<RaptorComponentViewModel>({
                    title: 'Description',
                    key: 'description',
                }),
            ],
            rowSelection: {
                type: 'checkbox',
                selectedRowKeys: props.selectedComponents.map((component) => component.uuid),
                onChange: (_, selectedRows: RaptorComponentViewModel[]): void => props.onChange(selectedRows),
            },
        }}
    />
);
